import { TAX_REGIMES } from '@/core/constants/taxRegimes';
import { RequiredRules } from './rules/index';

export function requiredFields(context) {
  for (const rule of RequiredRules) {
    if (rule.applies(context, TAX_REGIMES)) {
      return rule.fields(context);
    }
  }
  return [];
}
